<mat-card class="widget-card">
    <mat-card-header>
      <mat-card-title>{{currentBalance | currency}}</mat-card-title>
      <mat-card-subtitle>All Accounts Balance</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
    </mat-card-content>
  </mat-card>